"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowListGroup = exports.PartnerLinks = exports.ListItemWrapper = exports.LinksRow = exports.InteractionWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreListGroup = _interopRequireDefault(require("@legacy-vfuk/core-list-group"));

var _coreListItem = _interopRequireDefault(require("@legacy-vfuk/core-list-item"));

var _coreInteraction = _interopRequireDefault(require("@legacy-vfuk/core-interaction"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PartnerLinks = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "PartnerLinksstyle__PartnerLinks",
  componentId: "sc-1wc0z1f-0"
})(function () {
  return (0, _styledComponents.css)(["img{max-width:64px;max-height:40px;object-fit:cover;}"]);
});
exports.PartnerLinks = PartnerLinks;
var ListItemWrapper = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "PartnerLinksstyle__ListItemWrapper",
  componentId: "sc-1wc0z1f-1"
})(function () {
  return (0, _styledComponents.css)(["display:flex;"]);
});
exports.ListItemWrapper = ListItemWrapper;
var InteractionWrapper = (0, _styledComponents["default"])(_coreInteraction["default"]).withConfig({
  displayName: "PartnerLinksstyle__InteractionWrapper",
  componentId: "sc-1wc0z1f-2"
})(function (props) {
  var _props$footerTheme$ap = props.footerTheme.appearance[props.appearance].partnerLink,
      color = _props$footerTheme$ap.color,
      hoverColor = _props$footerTheme$ap.hoverColor;
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;justify-content:center;align-items:center;", " transition:0.4s all ease;color:", ";&:hover{text-decoration:underline;color:", ";}"], (0, _coreMixins.spacing)('gap', 3), color, hoverColor);
});
exports.InteractionWrapper = InteractionWrapper;
var LinksRow = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "PartnerLinksstyle__LinksRow",
  componentId: "sc-1wc0z1f-3"
})(function () {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;", " &:first-child{", "}"], (0, _coreMixins.spacing)('margin-top', 6), (0, _coreMixins.spacing)('margin-top', 0));
});
exports.LinksRow = LinksRow;
var RowListGroup = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "PartnerLinksstyle__RowListGroup",
  componentId: "sc-1wc0z1f-4"
})(function () {
  return (0, _styledComponents.css)(["display:flex;"]);
});
exports.RowListGroup = RowListGroup;
//# sourceMappingURL=PartnerLinks.style.js.map